<template>
  <v-flex >
    <v-row
      align="start"
    >  
      <table style="font-size: 12px;" v-if="breakdown">
        <tr>
          <td class="cmr-label-text">Base Fare</td>
          <td></td>
          <td class="cmr-value-text">£{{ (breakdown.baseFare / 100).toFixed(2) }}</td>
        </tr>
        <tr>
          <td class="cmr-label-text">Duration</td>
          <td v-if="booking != null && booking.state == 'completed'" class="cmr-value-text">{{ tripDuration() }} mins</td>
          <td v-else class="cmr-value-text">{{ breakdown.time_in_minutes }} mins</td>
          <td class="cmr-value-text">£{{ (breakdown.perMinuteCost / 100).toFixed(2) }}</td>
        </tr>
          <tr>
          <td class="cmr-label-text">Mileage</td>
          <td class="cmr-value-text">{{ breakdown.distance_in_miles.toFixed(2) }} miles</td>
          <td class="cmr-value-text">£{{ (breakdown.perMileCost / 100).toFixed(2) }}</td>
        </tr>
        <tr v-if="booking.waiting_time != null">
          <td class="cmr-label-text">Waiting Time</td>
          <td class="cmr-value-text">{{ booking.waiting_time.minutes_waited }} mins</td>
          <td class="cmr-value-text">£{{ (booking.waiting_time.charge / 100).toFixed(2) }}</td>
        </tr>
          <tr>
          <td class="cmr-label-text">Additionals</td>
          <td></td>
          <td class="cmr-value-text">£{{ (breakdown.additionals / 100).toFixed(2) }}</td>
          <td></td>
        </tr>
          <tr>
          <td class="cmr-label-text">Total</td>
          <td></td>
          <td class="cmr-value-text">£{{ ((breakdown.baseFare + breakdown.perMileCost + breakdown.perMinuteCost + breakdown.additionalCharge + breakdown.additionals) / 100).toFixed(2) }}</td>
        </tr>
      </table>
    </v-row>
  </v-flex>
</template>

<script>

import moment from 'moment'

export default {
  name: "FareBreakdown",
  components: {
  },
  props: {
    breakdown: Object,
    booking: {
      default: null,
      type: Object
    },
  },
  data() {
    return {};
  },
  computed: {
    waitingTime() {
      if (!this.booking) {
        return 0
      }
      let arrivedTime = moment(this.booking.arrived_time, "DD/MM/YYYY HH:mm")
      let pobTime = moment(this.booking.pob_time, "DD/MM/YYYY HH:mm")

      let difference = pobTime.diff(arrivedTime);
      return this.convertMillisecondsToMinutes(difference)
    }
  },
  methods: {
    tripDuration() {
      if (!this.booking) {
        return 0
      }
      let pobTime = moment(this.booking.pob_time, "DD/MM/YYYY HH:mm")
      let finishedTime = moment(this.booking.finished_time, "DD/MM/YYYY HH:mm")

      let difference = finishedTime.diff(pobTime);
      return this.convertMillisecondsToMinutes(difference)
    },
    convertMillisecondsToMinutes(ms) {
      if (ms > 0) {
        return (ms / 1000) / 60
      }
      return 0
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.cost-amount {
  font-size: 12px;
  font-weight: 500;
}

.est-text {
  font-size: 12px;
  font-weight: 700;
}
</style>
